import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    actionsLoading: false,
    listLoading: false,
    finalSettlementList: [],
    clearanceList: [],
    resignationApprovalList: [],
    interviewList: [],
    documentList: [],
    details: {},
    config: {},
    totalData: 0,
};
export const callTypes = {
    list: "list",
    action: "action",
};
export const finalSettlementSlice = createSlice( {
    name: "finalSettlement",
    initialState: initialState,
    reducers: {
        catchError: ( state, action ) => {
            state.error = `${action.type}: ${action.payload.error}`;
            if ( action.payload.callType === callTypes.list )
            {
                state.listLoading = false;
            } else
            {
                state.actionsLoading = false;
            }
        },
        startCall: ( state, action ) => {
            state.error = null;
            if ( action.payload.callType === callTypes.list )
            {
                state.listLoading = true;
            } else
            {
                state.actionsLoading = true;
            }
        },
        setListData: (state, action) =>{
            state.error = null;
            state.finalSettlementList = action.payload.finalSettlementList;
            state.totalData = action.payload.totalData;
            state.listLoading = false;
        },
        setClearanceListData: (state, action) =>{
            state.error = null;
            state.clearanceList = action.payload.data;
            state.listLoading = false;
        },
        setAllClearanceListData: (state, action) =>{
            state.error = null;
            state.clearanceListAll = action.payload.data;
            state.listLoading = false;
        },
        setClearanceDetailsData: (state, action) =>{
            state.error = null;
            state.clearanceDetails = action.payload.data;
            state.listLoading = false;
        },
        setResignationApprovalListData: (state, action) =>{
            state.error = null;
            state.resignationApprovalList = action.payload.data;
            state.listLoading = false;
        },
        setInterviewList: (state, action) =>{
            state.error = null;
            state.interviewList = action.payload.data;
            state.listLoading = false;
        },
        setInterviewDetails: (state, action) =>{
            state.error = null;
            state.interviewDetails = action.payload.data;
            state.listLoading = false;
        },
        setDocumentList: (state, action) => {
            state.error = null;
            state.documentList = action.payload.data;
            state.listLoading = false;
        },
        setDetailsData: (state, action) => {
            state.error = null;
            state.details = action.payload.data;
            state.listLoading = false;
        },
        setDetailsLightData: (state, action) => {
            state.error = null;
            state.detailsLight = action.payload.data;
            state.listLoading = false;
        },
        setBreakdownData: (state, action) => {
            state.error = null;
            state.breakdown = action.payload.data;
            state.listLoading = false;
        },
        cleanFinalSettlementData: (state, action) => {
            state.clearanceList = [];
            state.resignationApprovalList = [];
            state.interviewList = [];
            state.documentList = [];
            state.details = null;
        },
        cleanFinalSettlementLightData: (state, action) => {
            state.detailsLight = null;
        },
        setFinalSettlementConfig: (state, action) => {
            state.error = null;
            state.config = action.payload.data;
            state.listLoading = false;
        },
        setFinalSettlementTypeConfig: (state, action) => {
            state.error = null;
            state.typeConfig = action.payload.data;
            state.listLoading = false;
        },
        setFinalSettlementCurrentConfig: (state, action) => {
            state.error = null;
            state.currentConfig = action.payload.data;
            state.listLoading = false;
        },
        setFinalSettlementHrTopSheet: (state, action) => {
            state.error = null;
            state.hr_topsheet = action.payload.data;
            state.listLoading = false;
        },
        setFinalSettlementHrTopSheetEss: (state, action) => {
            state.error = null;
            state.hr_topsheet_ess = action.payload.data;
            state.listLoading = false;
        },
        setAccountDetails: (state, action) => {
            state.error = null;
            state.account_details = action.payload.data;
            state.listLoading = false;
        },
        setAccountBalance: (state, action) => {
            state.error = null;
            state.account_balance = action.payload.data;
            state.listLoading = false;
        }
    }
} );